export const GET_PROFILE_SUCCESS = "app/profile/GET_PROFILE_SUCCESS";
export const GET_SUBSCRIPTION_SUCCESS = "app/profile/GET_SUBSCRIPTION_SUCCESS";
export const GET_GOOGLE_PLAN_ID_SUCCESS = "app/profile/GET_GOOGLE_PLAN_ID_SUCCESS";
export const GET_PAYMENTS_SUCCESS = "app/profile/GET_PAYMENTS_SUCCESS";
export const DELETE_ACCOUNT_SUCCESS = "app/profile/DELETE_ACCOUNT_SUCCESS";
export const UPDATE_PROFILE_SUCCESS = "app/profile/UPDATE_PROFILE_SUCCESS";
export const UNSUBSCRIBE_SUCCESS = "app/profile/UNSUBSCRIBE_SUCCESS";